import React from "react";
import { Link } from "react-router-dom";
import { Tv, MonitorPlay, ArrowLeft, ArrowRight, Home as HomeIcon } from "lucide-react";
import { Seo, serviceJsonLd } from "../components/Seo";

const SERVICES = [
  {
    slug: "smart-tv",
    name: "Hemkurs för Smart-TV",
    Icon: Tv,
    desc: "Lär dig din Smart-TV: installera appar, titta på streamingtjänster, casta från mobilen och ställa in allt efter dina önskemål.",
  },
  {
    slug: "tv-box",
    name: "Hemkurs för TV-box",
    Icon: MonitorPlay,
    desc: "Lär dig din TV-box från t.ex. Telia, Tele2, Comhem eller Allente: navigera i menyerna, hitta dina kanaler och använda play-tjänster.",
  },
];

export default function CourseLanding() {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-10 md:py-14">
      <Seo
        title="Boka hemkurs för Smart-TV och TV-box"
        description="Personlig hemkurs där vi kommer hem till dig och lär dig din Smart-TV eller TV-box i lugn takt. Fast pris 1 995 kr inkl. moms, framkörning ingår."
        path="/hemkurs"
        jsonLd={serviceJsonLd({ name: "Hemkurs Smart-TV & TV-box", description: "Personlig hemkurs för Smart-TV och TV-box i ditt eget hem.", path: "/hemkurs", price: 1995 })}
      />
      <Link to="/" data-testid="course-landing-back" className="inline-flex items-center gap-2 text-lg font-semibold text-[#0056D2] hover:underline">
        <ArrowLeft size={22} strokeWidth={2.5} /> Tillbaka till start
      </Link>

      <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-[#1A1A1A] mt-6">Boka hemkurs</h1>
      <p className="text-lg md:text-xl leading-relaxed text-[#4A4A4A] mt-4">
        Vi kommer hem till dig och lär dig lugnt och tydligt hur din teknik fungerar – i din egen takt.
      </p>
      <p className="text-lg md:text-xl leading-relaxed text-[#4A4A4A] mt-4">
        Välj den kurs du vill boka nedan.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-10">
        {SERVICES.map(({ slug, name, Icon, desc }) => (
          <div key={slug} data-testid={`service-card-${slug}`}
            className="bg-white border-2 border-gray-300 rounded-xl p-8 flex flex-col hover:border-[#0056D2] transition-colors">
            <span className="bg-blue-50 text-[#0056D2] rounded-2xl p-5 self-start">
              <Icon size={48} strokeWidth={2} />
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1A1A1A] mt-5">{name}</h2>
            <p className="text-lg text-[#4A4A4A] mt-3 flex-1">{desc}</p>
            <p className="font-heading text-2xl font-extrabold text-[#1A1A1A] mt-5">1 995 kr <span className="text-base font-medium text-[#4A4A4A]">inkl. moms</span></p>
            <Link to={`/hemkurs/${slug}`} data-testid={`service-book-${slug}`}
              className="inline-flex items-center justify-center gap-3 min-h-[64px] w-full px-6 mt-5 bg-[#0056D2] text-white text-xl font-bold rounded-lg hover:bg-[#003E99] transition-colors">
              Läs mer och boka <ArrowRight size={24} strokeWidth={2.5} />
            </Link>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link to="/" className="inline-flex items-center gap-2 text-lg font-semibold text-[#0056D2] hover:underline">
          <HomeIcon size={22} strokeWidth={2.5} /> Tillbaka till start
        </Link>
      </div>
    </div>
  );
}
